import React from 'react';

import { Image, Images } from 'theme/images';

import { AppLink, AppLinksSection } from './styles';

export const appStoreLinks = [
  {
    imageName: Images.getGoogle,
    label: 'Naked Insurance on the Google Play Store',
    href: Config.Shared.Links.App.GOOGLE_URL,
  },
  {
    imageName: Images.getApple,
    label: 'Naked Insurance on the Apple App Store',
    href: Config.Shared.Links.App.APPLE_URL,
  },
  {
    imageName: Images.getHuawei,
    label: 'Naked Insurance on the Huawei App Gallery',
    href: Config.Shared.Links.App.HUAWEI_URL,
  },
];

/**
 * `AppLinks` is a functional component that renders a section with app store links in the footer.
 * The section is displayed as a grid on screens smaller than 1024px and as a flex container on larger screens.
 * Clicking on a link opens it in a new tab.
 *
 * @example
 * return (
 *   <AppLinks />
 * )
 */
export function AppLinks() {
  return (
    <AppLinksSection about="App store links">
      {appStoreLinks.map(({ imageName, href, label }) => (
        <AppLink aria-label={label} key={imageName} href={href} target="_blank" rel="noreferrer">
          <Image alt={label} src={imageName} loading="lazy" style={{ height: '32px' }} />
        </AppLink>
      ))}
    </AppLinksSection>
  );
}
